<template>
 <div>
<topbar></topbar>

<div class="clear"></div>
<sortHeader></sortHeader>

<!--顶部：导航 开始-->
<heardernav ref="navComp" :activeLi="activeLi" firstCatShow=true></heardernav>
<!--顶部：导航 结束-->

<!--焦点新闻 开始-->
<div class="shop-focus-img">
		<mt-swipe :auto="3000" :speed="1000" style="height:405px;cursor:pointer;">
			<!--@click不起作用添加，原始的onclick事件，定义在index.html中-->
		  <mt-swipe-item v-for="(i, index) in sliderItems"  onclick="jumpUrl(this)"  :key="index" :style="{background: 'url(' + i.mediaCode + ')'+'no-repeat center top'}">
		  	 <a style="display: none;">{{i.link}}</a>
		  </mt-swipe-item>
		</mt-swipe>
</div>
<!--焦点新闻 结束-->

<div class="clear mt15"></div>
<!--container 开始-->
<div class="container">
	<!--热门店铺 开始-->
    <!--<div class="hot-store">
    	<ul>
        	<li v-for="hotShop in hotShopList" @click="goShop(hotShop.shopCode)">
            	<a><img v-bind:src="imgPath + hotShop.shopLogo" width="285" height="155"></a>
                <div class="shop-name"><a class="co1">{{hotShop.shopName}}</a></div>
            </li>
        </ul>
    </div>-->
    <!--热门店铺 结束-->
	<!--热门推荐 开始-->
<div class="recommend" style="border: solid 1px #ddd;margin-bottom: 20px;">
        <div class="hd1"><h3 class="hd-tit1">热门推荐</h3>
        	<a v-if="cabinetId!=null&&cabinetId!=''&&hotGoodsList!=null&&hotGoodsList.length>0" class="more" @click="jumpToCabinet()">更多 ></a>
        </div>
        <mt-swipe :show-indicators="false" style="height: 280px;">
			  <mt-swipe-item>
			  		<div class="bd" style="line-height: 0px;">
			        	<ul class="items li5">
			            	<li v-for="hotGood in hotGoodsList" @click="goDetail(hotGood.goodsCode)">
			           	    	<a><img v-bind:src="imgPath + hotGood.imgMiddle" width="210" height="210"></a>
			                    <div class="line-tit"><a class="co4" >{{hotGood.goodsName}}</a></div>
			                    <div class="line-price" v-if="hotGood.goodsPrice==0"><span class="co2">{{hotGood.unitPrice==0?"":"￥"+(hotGood.unitPrice/100).toFixed(2)}}</span></div>
			                    <div class="line-price" v-else>
			                    	<span class="co2">
				                    	{{hotGood.goodsPrice}}
										<span v-if="hotGood.pointType == 'point'">积分</span>
										<span v-else-if="hotGood.pointType == 'special'">专用积分</span>
										<span v-else-if="hotGood.pointType == 'red'">红积分</span>
										<span v-else-if="hotGood.pointType == 'blue'">蓝积分</span>
			                    	</span>
			                    </div>
			                    
			                </li>
			            </ul>
			        </div>
			  </mt-swipe-item>
			  <mt-swipe-item v-if="secondPageShow">
			  		<div class="bd" style="line-height: 0px;">
			        	<ul class="items">
			            	<li v-for="hotGood in hotSecondList" @click="goDetail(hotGood.goodsCode)">
			           	    	<a><img v-bind:src="imgPath + hotGood.imgMiddle" width="210" height="210"></a>
			                    <div class="line-tit"><a class="co4" >{{hotGood.goodsName}}</a></div>
			                    <div class="line-price" v-if="hotGood.goodsPrice==0" ><span class="co2">{{hotGood.unitPrice==0?"":"￥"+(hotGood.unitPrice/100).toFixed(2)}}</span></div>
			                	<div class="line-price" v-else>
			                		<span class="co2">
			                			{{hotGood.goodsPrice}}
										<span v-if="hotGood.pointType == 'point'">积分</span>
										<span v-else-if="hotGood.pointType == 'special'">专用积分</span>
										<span v-else-if="hotGood.pointType == 'red'">红积分</span>
										<span v-else-if="hotGood.pointType == 'blue'">蓝积分</span>
			                		</span>
			                	</div>
			            	</li>
			            </ul>
			        </div>
			  </mt-swipe-item>
		</mt-swipe>

    </div>
    <!--热门推荐 结束-->

  <!--抢购 开始-->
  <div v-show="secKillBo!=null&&secKillBo!=''">
  <div class="recommend" style="margin-bottom: 20px;height: 350px;">
  	<a class="more1" @click="jumpTo('seckillList')">更多 ></a>
    <div class="hd"><h3 class="hd-tit">抢购</h3></div>
    <div class="buying">
      <ul>
        <li class="shopTime">
          <h1 style="width: 231px;">抢购</h1>
          <h2 class="eg">FLASH DEALS</h2>
          <img style="width: 64px;height: 64px;" src="../.././../static/images/lightning.png">
          <p style="font-size: 18px;margin-bottom: 10px;">{{activityName}}</p>
          <div class="clock" style="margin:2em;"></div>
        </li>
        <li v-for="(list,index) in seckillGoods"  v-if="index<4">
        	<a @click="goDetail(list.goodsCode)">
        		<img :src="imgPath+(list.imgMiddle!=null?(list.imgMiddle.split(';'))[0]:'')">
          <p>{{list.goodsName}}</p>
          <div class="priceBox">
            <span class="currentPrice">￥{{list.seckillPrice/100}}</span>
            <span class="originalPrice">{{list.unitPrice==0?"":"￥"+list.unitPrice/100}}</span>
          </div>
          </a>
        </li>
        

      </ul>
    </div>
  </div>
  </div>
  <!--抢购 结束-->

    <!--商城快报 开始
	<div class="mall-express" style="padding-bottom: 1px;">
    	<h3 class="hd-tit">商城快报</h3>
        <ul class="bd">
        	<li v-for="newBo in newList">
           		<a :href="exchangeUrl+newBo.url">{{newBo.title}}</a>
            </li>
        </ul>
    </div>
    <div  style="margin-top: 14px;">
        <a :href="littleAdsItem.link">
         <img :src="littleAdsItem.mediaCode" style=" width: 240px; height: 105px;">
        </a>
    </div>
    -->
    <!--商城快报 结束
    <div class="clear mt15"></div>-->
    
    <div class="clear mt15"></div>
    <!--女装专区 开始-->
<!--
<div class="grid-c1 suit-dress" v-bind:class='{"grid-c1-height":index == 0||index == 1||index == 2}' v-for="(cat,index) in firstCatList">
	<div class="grid-c1 suit-dress" v-bind:class='{"grid-c1-height":index <innerAdsNum}'>
	-->
	<div  v-for="(cat,index) in firstCatList">
	<div class="grid-c1 miaosha" v-if="cat.catCode == 'spike'&&cat.goodsList.length>0">
	  	<div class="side-l">
        	<div class="hd">
            	<a class="more" @click="getMore(cat.catCode,cat.catNameCn)">更多 ></a>
       	  		<ul class="tags">
                	<li v-for="(childCat, idx) in cat.catBoList" v-if="idx<8">
                		<a @click="getCatGoods(childCat.catCode,childCat.catCode,childCat.catNameCn)">{{childCat.catNameCn}}</a>
                	</li>
                </ul>
                <h3><i class="ico-3"></i>{{cat.catNameCn}}专区</h3>
          	</div>
            <div class="bd">
            	<ul class="items">
                    <li v-for="goodsBo in cat.goodsList">
                        <a @click="goDetail(goodsBo.goodsCode)"><img v-bind:src="profixPath+goodsBo.imgMiddle" width="197" height="197"></a>
                        <div class="line-tit"><a class="co4" href="#">{{goodsBo.goodsName}}</a></div>
                        <div class="line-price"><span class="co3">{{goodsBo.unitPrice==0?"":"￥"+(goodsBo.unitPrice/100).toFixed(2)}}</span><span class="old">￥{{(goodsBo.marketPrice/100).toFixed(2)}}</span></div>
                    	<div class="pinpainow_item_time">
                			<span class="brandsknow_time_txt"  v-if="goodsBo.saleStatus==='end'">
                				已结束
                			</span>
                			<span class="brandsknow_time_txt"  v-if="goodsBo.saleStatus==='wait_start'">
                				距开始 <i class="brandsknow_time_txt_time">{{goodsBo.hour}}</i>时<i class="brandsknow_time_txt_time">{{goodsBo.minute}}</i>分<i class="brandsknow_time_txt_time">{{goodsBo.second}}</i>秒
                			</span>
                			<span class="brandsknow_time_txt"  v-if="goodsBo.saleStatus==='on_sale'">
                				距结束 <i class="brandsknow_time_txt_time">{{goodsBo.hour}}</i>时<i class="brandsknow_time_txt_time">{{goodsBo.minute}}</i>分<i class="brandsknow_time_txt_time">{{goodsBo.second}}</i>秒
                			</span>
                    	</div>
                    </li>
              </ul>
        </div>
     </div>

  	</div>
  	<div class="grid-c1 suit-dress" v-if="cat.catCode != 'spike'&&cat.goodsList.length>0">
  	  <div class="side-l" >
        	<div class="hd">
            	<a class="more" @click="getMore(cat.catCode,cat.catNameCn)">更多 ></a>
       	  		<ul class="tags">
                	<li v-for="(childCat, idx) in cat.catBoList" v-if="idx<8">
                		<a @click="getCatGoods(childCat.catCode,childCat.catNameCn)">{{childCat.catNameCn}}</a>
                	</li>
                </ul>
                <h3>{{cat.catNameCn}}专区<!--{{cat.catName.toUpperCase()}}--></h3>
          	</div>
            <div class="bd">
            	<a class="showpic" @click="getMore(cat.catCode,cat.catNameCn)"><img v-bind:src="cat.picPath" width="300" height="550"></a>
            	<ul class="items">
                    <li v-for="goodsBo in cat.goodsList">
                        <a @click="goDetail(goodsBo.goodsCode)"><img v-bind:src="profixPath+goodsBo.imgMiddle" width="197" height="197"></a>
                        <div class="line-tit"><a class="co4" href="#">{{goodsBo.goodsName}}</a></div>
                        <div class="line-price" v-if="goodsBo.goodsPrice==0"><span class="co3">{{goodsBo.unitPrice==0?"":"￥"+(goodsBo.unitPrice/100).toFixed(2)}}&nbsp;</span></div>
                        <div class="line-price" v-else>
                        	<span class="co3">
                        		{{goodsBo.goodsPrice}}
								<span v-if="goodsBo.pointType == 'point'">积分</span>
								<span v-else-if="goodsBo.pointType == 'special'">专用积分</span>
								<span v-else-if="goodsBo.pointType == 'red'">红积分</span>
								<span v-else-if="goodsBo.pointType == 'blue'">蓝积分</span>&nbsp;
                        	</span>
                        </div>
                    </li>
              </ul>
        </div>
      </div>
      </div>
  	<div class="clear mt15"></div>
      <div  v-for="(ads,ads_idx) in adsItem" v-if="index == ads_idx" style="margin-top: 15px;"><a :href="ads.link"><img :src="ads.mediaCode" width="1200" height="130"></a></div>
      <div class="clear mt15"></div>
  	</div>
    <!--女装专区 结束-->
    <div class="top" v-on:click="scrollToTop()">
		<a><span>TOP</span></a>
	</div>
    <div class="clear mt20"></div>

</div>
<div v-if="bottomAdsItem.mediaCode!=null" style="padding-bottom: 0.8rem;width: 1200px;margin: auto;"><img :src="bottomAdsItem.mediaCode" width="1200" height="60"></div>
<!--container 结束-->
<footermenu></footermenu>
		<footercopyright></footercopyright>

  	
  </div>
</template>
<script>
/*引入Vue框架*/
import Vue from 'vue'
/*引入资源请求插件*/
import VueResource from 'vue-resource'
/*使用VueResource插件*/
Vue.use(VueResource)
import jQuery from 'jquery';
import TopBar from '@/components/TopBar'
import Header from '@/components/Header'
import FooterMenu from '@/components/FooterMenu'
import FooterCopyright from '@/components/FooterCopyright'
import HearderNav from '@/components/HearderNav'
import API from "../../../static/api/api.js"
import flipClock from "../../../static/js/flipclock.min.js"
import {getImgUrl,getCmsUrl,getIndexUrl,getUcUrl,getAboutUsUrl,sysContactUrl,dateFormat,compareDate} from "../../../static/js/emallUtils.js"
import { Swipe, SwipeItem } from 'mint-ui';
Vue.component(Swipe.name, Swipe);
Vue.component(SwipeItem.name, SwipeItem);

export default {
  name: 'index',
  data () {
    return {
       activeLi:"mallIndex",
       sliderItems:[],
       littleAdsItem:{},
       adsItem:[],
       innerAdsNum:0,
       bottomAdsItem:{},
       sliderHeight: '405px',
       firstCatList:[],
       hotGoodsList:[],
       hotSecondList:[],
       hotShopList:[],
       secondPageShow:false,
       cabinetId:'',//首页橱窗ID
       profixPath:'',
       isLogin:false,
	   isShow:false,
	   account:'',
	   userCenterUrl:'',
		loginUrl:'',
		registerUrl:'',
		logoutUrl:'',
		aboutUsUrl:'',
		indexUrl:'',
	   newList:[],
	   exchangeUrl:'',
	   imgPath:'',
	   contactUrl:'',
	   computeFlag:'',
	   secKillBo:'',
		nextActivityTime:'',
		seckillGoods:[],
		seckillHour:'0',
		seckillMinute:'0',
		seckillSecond:'0',
		activityName:'',//秒杀活动开始标识
		currentDate:null,//系统当前时间
		clock:''//倒计时组件
    }
  },
  components:{
       'topbar':TopBar,
       'sortHeader':Header,
       'footermenu':FooterMenu,
	   'footercopyright':FooterCopyright,
	   'heardernav':HearderNav
  },
  methods:{
  	getIndexAds:function(){
  		var that = this;
		API.getIndexAds(function(ret){
			if(ret.code == "success" && ret.data.adsList.length > 0){
					var adsList = ret.data.adsList;
		 			if(adsList != undefined && adsList.length>0){
		     		 		var sliderItems = new Array();
		     		 		for(var i=0;i<adsList.length;i++){
		     		 			 adsList[i].mediaCode = getImgUrl() + "/upload/show.htm?filePath=" + adsList[i].mediaCode;
		     		 			 if(adsList[i].adsType == "slider"){
		     		 			 		sliderItems.push(adsList[i]);
		     		 			 }else if(adsList[i].adsType == "little_ads"){
		     		 			 	  that.littleAdsItem = adsList[i];
		     		 			 }else if(adsList[i].adsType == "inner_ads"){
		     		 			 	  that.innerAdsNum++;
		     		 			 	  that.adsItem.push(adsList[i]);
		     		 			 }else if(adsList[i].adsType == "bottom_slogen"){
		     		 			 	  that.bottomAdsItem = adsList[i];
		     		 			 }
		     		 		}
		     		 		that.sliderItems = sliderItems;
		     		 }
			}
		});
  	},
  	getRecommendGoods:function(){
  		var that = this;
  		var pageSize = 10;
  		var src = "pc";
		API.getRecommendGoods(pageSize,src,function(ret){
			var goodsList = ret.data.goodsList;
			that.cabinetId=ret.data.cabinetId;
			if(ret.code == "success" && goodsList!= undefined &&  goodsList.length > 0){
				for(var i=0;i<goodsList.length;i++){
					var imgMiddle = goodsList[i].imgMiddle;
					if(imgMiddle.indexOf(";")>=0){
						imgMiddle = imgMiddle.split(";")[0];
						goodsList[i].imgMiddle = imgMiddle;
					}
				}
				var listLength = goodsList.length;
				if(listLength <= 6){
					that.hotGoodsList = goodsList;
				}else if(listLength > 6){
					that.hotGoodsList = goodsList.slice(0,6);
					that.hotSecondList = goodsList.slice(6,listLength.length);
					that.secondPageShow = true;
				}

			}
		});
  	},
  	getRecommendShops:function(){
  		var that = this;
  		var pageSize = 8;
  		var src = "pc";
		API.getRecommendShops(pageSize,src,function(ret){
			if(ret.code == "success" && ret.data.shopList.length > 0){
					that.hotShopList = ret.data.shopList;
			}
		});
  	},
  	logout:function(){
		localStorage.clear();
		API.loginOut(function(ret){});
		window.location.href = this.logoutUrl;
	},
  	 mobileAppShow:function(){
  		this.isShow = true;
  	 },
  	 mobileAppHidden:function(){
  		this.isShow = false;
  	 },
  	 jumpTo:function(name){
  		this.$router.push({ name:name});
  	 },
  	 jumpToCabinet:function(name){
  		window.location.href=getCmsUrl()+"/custom.htm?tplName=More&c="+this.cabinetId;
  	 },
  	 goDetail:function(goodsCode){
  	 	//this.$router.push({name:'goodsdetail',query:{goodsCode:goodsCode}});
		let routeData = this.$router.resolve({ path: '/goodsDetails', query: {goodsCode: goodsCode } });
		window.open(routeData.href, '_blank');
  	 },
  	 goShop:function(shopCode){
  	 	this.$router.push({name:'shop_index',query:{shopCode:shopCode}});
  	 },
  	 getBrandGoods:function(brandId,brandName){
  	 	this.$router.push({name:'goodsList',query:{brandId:brandId,brandName:brandName}});
  	 },
  	 getMore:function(catCode,catNameCn){
	 	if(catCode =="point_use_area"){
//			this.$router.push({name:'points_area',query:{}});
			window.open("/#/points_area",'_blank');
		}else{
			this.$router.push({name:'goodsList',query:{firstCatCode:catCode,catNameCn:catNameCn}});
		}
  	 },
  	 getCatGoods:function(catCode,catNameCn){
  	 	this.$router.push({name:'goodsList',query:{catCode:catCode,catNameCn:catNameCn}});
  	 },
	 getIndexInfo:function(){
	 	var that = this;
	 	API.getIndex(function(ret){
	 		if(ret.code == "success" && ret.data != undefined){
	 			var account = ret.data.account;

	 			if(account != undefined && account != ""){
	 				that.isLogin = true;
	 				that.account = account;
	 				localStorage.setItem("account",account)
	 			}

	 			var firstCatList = ret.data.firstCatList;

	 			if(firstCatList != undefined && firstCatList.length >0){
	 				for(var i=0;i<firstCatList.length;i++){
	 					var picPath = firstCatList[i].picPath;
	 					picPath = getImgUrl() + "/upload/show.htm?filePath=" + picPath;
	 					firstCatList[i].picPath = picPath;
	 					for(var j=0;j<firstCatList[i].goodsList.length;j++){
	 						var marketPrice=JSON.parse(firstCatList[i].goodsList[j].attrValue).marketPrice;
	 						var saleTimeStr=JSON.parse(firstCatList[i].goodsList[j].attrValue).saleTimeShow;
	 						var saleEndTimeStr=JSON.parse(firstCatList[i].goodsList[j].attrValue).saleEndTimeShow;
	 						if(marketPrice!=undefined && marketPrice!=""){
	                    		firstCatList[i].goodsList[j].marketPrice=marketPrice;
			 				}else{
			 					firstCatList[i].goodsList[j].marketPrice=firstCatList[i].goodsList[j].unitPrice;
			 				}
			 				if(saleEndTimeStr!=undefined&&saleEndTimeStr!=''){
			 					saleEndTimeStr=saleEndTimeStr.replace(/-/g,"/");
								var saleEndDate = new Date(saleEndTimeStr);

								saleTimeStr=saleTimeStr.replace(/-/g,"/");
								var saleDate = new Date(saleTimeStr);

								//如果当期日期大于销售结束日期 xxx
								if(new Date() > saleEndDate){
									firstCatList[i].goodsList[j].saleStatus="end";
								}else if(new Date() < saleDate){//如果当期时间小于上架时间，展示距离开始 时间
									firstCatList[i].goodsList[j].saleStatus="wait_start";
									var begSeconds = saleDate.getTime() - new Date().getTime();   //时间差的毫秒数
    								//计算出相差天数
//  								var days=Math.floor(begSeconds/(24*3600*1000));
    								//计算出小时数
    								var leave1=begSeconds%(24*3600*1000);    //计算天数后剩余的毫秒数
    								var hours=Math.floor(begSeconds/(3600*1000));
    								//计算相差分钟数
    								var leave2=leave1%(3600*1000);        //计算小时数后剩余的毫秒数
    								var minutes=Math.floor(leave2/(60*1000));
    								//计算相差秒数
    								var leave3=leave2%(60*1000);      //计算分钟数后剩余的毫秒数
   									var seconds=Math.round(leave3/1000);
// 									firstCatList[i].goodsList[j].day=days;
   									firstCatList[i].goodsList[j].hour=hours;
   									firstCatList[i].goodsList[j].minute=minutes;
   									firstCatList[i].goodsList[j].second=seconds;
								}else{
									firstCatList[i].goodsList[j].saleStatus="on_sale";

									var begSeconds = saleEndDate.getTime() - new Date().getTime();   //时间差的毫秒数
    								//计算出相差天数
//  								var days=Math.floor(begSeconds/(24*3600*1000));
    								//计算出小时数
    								var leave1=begSeconds%(24*3600*1000);    //计算天数后剩余的毫秒数
    								var hours=Math.floor(begSeconds/(3600*1000));
    								//计算相差分钟数
    								var leave2=leave1%(3600*1000);        //计算小时数后剩余的毫秒数
    								var minutes=Math.floor(leave2/(60*1000));
    								//计算相差秒数
    								var leave3=leave2%(60*1000);      //计算分钟数后剩余的毫秒数
   									var seconds=Math.round(leave3/1000);
// 									firstCatList[i].goodsList[j].day=days;
   									firstCatList[i].goodsList[j].hour=hours;
   									firstCatList[i].goodsList[j].minute=minutes;
   									firstCatList[i].goodsList[j].second=seconds;
								}
			 				}

	 					}
	 				}
	 			}
	 			that.firstCatList = firstCatList;
	 			that.profixPath = getImgUrl() + "/upload/show.htm?filePath=";
	 		}
	 	});
	 },
	getNews:function(){
		var that = this;
		var params = '{}';
			jQuery.ajax({
                type: "get",
                url: getIndexUrl()+'/sckb/index.htm',
                async:false,
                dataType : "jsonp", // 返回的数据类型，设置为JSONP方式
                data: params,
                success:function(ret){
                	if(ret.code == 'success'){
                		var newList = ret.values.list;
                		if(newList != undefined && newList.length>0){
                			that.newList = newList;
                		}
                	}
                },
                error: function (err) {

                }
            })
	},
  	goIndex:function(){
  		this.$router.push({name:'index'});
  	},
 	getCat:function(){
		var that = this;
		API.getAllCat('',function(ret){
			if(ret.code == "success"){
				var firstCatList = ret.data.firstCatList;
			}
		});
	},
	computeTime:function(){
		var that=this;
		//系统当前时间
		if(that.currentDate!=null&&that.currentDate!=undefined){
			that.currentDate = new Date(that.currentDate.getTime() + 1000);
		}
				if(that.secKillBo != '' && that.secKillBo != undefined) {
					//默认展示距离活动结束时间
					var activityBeginTime = new Date(dateFormat(that.secKillBo.activityBeginTime + "").replace(/-/g, "/"));
					var activityEndTime = new Date(dateFormat(that.secKillBo.activityEndTime + "").replace(/-/g, "/"));
					var showTime=activityEndTime;
					//如果当前活动开始了
					if(compareDate(activityBeginTime, that.currentDate) <= 0 && compareDate(activityEndTime, that.currentDate) >= 0){
						//that.activityName=that.secKillBo.activityName;
						that.activityName="本场距离结束还剩：";
					}else if(compareDate(activityBeginTime, that.currentDate) > 0){
						that.activityName="本场距离开始还剩：";
						showTime=activityBeginTime;
					}else{
						window.clearInterval(that.computeFlag);
						that.secKillBo=null;//停止秒杀活动展示
						that.getSeckillActivityList();//重新查询秒杀活动
					}
//					var begSeconds = showTime.getTime() - new Date().getTime(); //时间差的毫秒数   
//					//计算出小时数  
//					var leave1 = begSeconds % (24 * 3600 * 1000); //计算天数后剩余的毫秒数  
//					var hours = Math.floor(begSeconds / (3600 * 1000));
//					//计算相差分钟数  
//					var leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数  
//					var minutes = Math.floor(leave2 / (60 * 1000));
//					//计算相差秒数  
//					var leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数  
//					var seconds = Math.round(leave3 / 1000);
//					if(hours < 10) {
//						hours = "0" + hours
//					}
//					if(minutes < 10) {
//						minutes = "0" + minutes
//					}
//					if(seconds < 10) {
//						seconds = "0" + seconds
//					}
//					that.hour = hours + "";
//					that.minute = minutes + "";
//					that.second = seconds + "";
				}
	},
			handleScroll: function(e) {
				if(Math.abs(e.currentTarget.scrollY) > 300) {
					jQuery(".top").show();
				} else {
					jQuery(".top").hide();
				}
			},
			scrollToTop: function() {
				jQuery("html,body").animate({
					scrollTop: 0
				}, 500);
			},
	//判断是否在活动时间内
			compareActTime: function(actBeginTime,actEndTime) {
				var that = this;
				var beginTime=new Date(dateFormat(actBeginTime + "").replace(/-/g, "/"));
				var endTime=new Date(dateFormat(actEndTime + "").replace(/-/g, "/"));
				if(that.currentDate==null||that.currentDate==undefined||actBeginTime==null||actBeginTime==undefined
					||actEndTime==null||actEndTime==undefined){
					return false;
				}else{
					if(compareDate(beginTime, that.currentDate) <= 0 && compareDate(endTime, that.currentDate) >= 0){
						return true;
					}else{
						return false;
					}
				}
			},
    initClock:function () {
      var that = this;
      
					//判断根据开始时间还是结束时间计算
   					var activityBeginTime = new Date(dateFormat(this.secKillBo.activityBeginTime + "").replace(/-/g, "/"));
					var activityEndTime = new Date(dateFormat(this.secKillBo.activityEndTime + "").replace(/-/g, "/"));
					var showTime=activityEndTime;
					//如果当前活动开始了
					if(compareDate(activityBeginTime, this.currentDate) <= 0 && compareDate(activityEndTime, this.currentDate) >= 0){
						//that.activityName='';
					}else if(compareDate(activityBeginTime, that.currentDate) > 0){
						//that.activityName="本场距离开始还剩：";
						showTime=activityBeginTime;
					}else{
						that.clock.stop();
					}
	  //根据时间进行计算差距
	  var begSeconds = showTime- new Date().getTime(); //时间差的毫秒数
      /*that.clock.setTime(begSeconds/1000);
	  that.clock.setCountdown(true);
      that.clock.start();*/
      that.clock = $('.clock').FlipClock(begSeconds/1000,{
        clockFace: 'HourlyCounter',
        countdown: true,
//      autoStart: false,
        callbacks: {              //回调函数
        	stop: function() { 
      			alert("stoped!"); 
        	}
    	} 
      });
    },
    getSeckillActivityList: function() {
				var that = this;
				API.getSeckillActivityList(function(ret) {
					if(ret.code == "success" && ret.data != undefined) {
						that.secKillBo = ret.data.secKillBo;
						that.currentDate = new Date(dateFormat(ret.data.currentTime + "").replace(/-/g, "/"));
//						that.nextActivityTime = ret.data.nextActivityTime;
						that.seckillGoods = ret.data.seckillGoods;
//						that.computeFlag = window.setInterval(function() {
//							that.computeTime1(); //计算倒计时
//						}, 1000);
						if(that.secKillBo!=null){
							that.initClock();
							that.computeFlag = window.setInterval(function(){
	 							that.computeTime();//计算倒计时
	 						},1000);
						}
						
					}
				});
	},
  },
  beforeDestroy () {
     window.clearInterval(this.computeFlag);
  },
  mounted(){
	this.$refs.navComp.getCat();
  	this.userCenterUrl = getUcUrl() + '/index/default.htm';
	this.loginUrl = getUcUrl() + '/login.htm';
//	this.registerUrl = 'http://uc.hcehce.com/custm/user/user_reg_add.htm';
	this.registerUrl = getUcUrl() + '/custm/user/user_reg_add.htm?formCode=MCHT_USER_FORM';
	this.logoutUrl = getUcUrl() + '/logout.htm';
	this.aboutUsUrl = getAboutUsUrl();
	this.indexUrl = getIndexUrl();
	this.exchangeUrl = getIndexUrl();
	this.imgPath = getImgUrl()+"/upload/show.htm?filePath=";
	window.scrollTo(0, 0);
 	this.getIndexInfo();
	this.getRecommendGoods();
	this.getRecommendShops();
	this.getIndexAds();
	 this.getCat();
	 //this.getNews();
	 this.contactUrl = sysContactUrl;
	 var that = this;
	 /*this.computeFlag = window.setInterval(function(){
	 	that.computeTime();//计算倒计时
	 },1000);*/

	 this.$nextTick(function() {
		window.addEventListener('scroll', this.handleScroll); //滚动事件监听
	 });
	 
	 this.getSeckillActivityList();
  }
}
</script>
<style>
.demensional_code{
	height: 100px;
    width: 100px;
    z-index: 99;
    background-color: gainsboro;
    position: absolute;
    right: 45px;
}
.grid-c1-height{
	height:800px;
}
.top {
     position: fixed;
     right: 8rem;
     bottom: 5rem;
     z-index: 99999;
     display: none;
}
.top span {
     border-radius: 50%;
     font-size: 2rem;
     width: 2.8em;
     height: 2.8em;
     line-height: 2.8;
     text-align: center;
     display: block;
     color: #fff;
     opacity: .9;
     background-color: #ff8381;
}
.buying{padding: 10px 22px;}
.buying ul{display: flex}
.buying li{
  display: inline-block;
  list-style: none; 
  width: 230px;	
}
.buying li img{
  width: 210px;
  height: 210px;
  display: block;
  margin: auto;
}
.buying li p{text-align: center;width: 100%;white-space: nowrap;
overflow: hidden;
text-overflow: ellipsis;}
.currentPrice{
  background: #E12816;
  color: #ffffff;
  display: inline-block;
  height: 30px;
  line-height: 30px;
  width: 90px;
  text-align: center;
  margin-top: 10px;
  margin-bottom: 10px;
}
.originalPrice{
  display: inline-block;
  width: 90px;
  height: 28px;
  line-height: 28px;
  color: gainsboro;
  border: 1px solid #E12816;
  text-decoration: line-through;
  margin-left: -6px;
  text-align: center;
}
.priceBox{
  margin: 0px auto;
  text-align: center;
  width: 100%;
}
.shopTime{
  background: #E12816;
  color: #ffffff;
  padding-top: 40px;
  width:238px;
}
.shopTime h1,.shopTime h2{
  text-align: center;
}
.shopTime .eg{color: #FE8E84}
.more1{
	float: right;
    display: block;
    padding: 0 20px;
    height: 24px;
    line-height: 24px;
    background: #fff;
    border: solid 1px #3983c5;
    border-radius: 12px;
    color: #3983c5;
    margin-top: 10px;
    margin-right: 20px;
}
.more{
    float: right;
    color: #F77400;
    font-weight: bold;
    padding-right: 20px;
    }
</style>



// WEBPACK FOOTER //
// src/page/index/index.vue?bfb54e94